import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import cn from 'classnames';

import { getScrollTop } from '@bibliocommons/utils-browser';
import './StickyToolbar.scss';

export class StickyToolbar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleScroll = _.throttle(this.handleScroll, 50).bind(this);
    this.handleResize = _.throttle(this.updateOffsets, 50).bind(this);

    this.state = {
      stickToTop: false,
      initialOffset: 0,
      toolbarHeight: 0,
      toolbarWidth: 0,
      toolbarLeft: 0,
      toolbarTop: 0
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);

    setTimeout(() => {
      this.updateOffsets();
      this.handleScroll();
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  shouldStickToTop(toolbarTop) {
    return getScrollTop() > this.state.initialOffset - toolbarTop;
  }

  handleScroll() {
    this.updateOffsets();

    const changes = {};

    changes.toolbarTop = this.props.getOffsetForStickyToolbar ? this.props.getOffsetForStickyToolbar() : 0;

    const shouldStickToTop = this.shouldStickToTop(changes.toolbarTop);

    if (this.state.stickToTop !== shouldStickToTop) {
      changes.stickToTop = shouldStickToTop;
    }

    this.setState(changes);
  }

  updateOffsets() {
    const changes = {};

    if (this._toolbarDiv) {
      changes.initialOffset =
        this._toolbarDiv.getBoundingClientRect().top + window.pageYOffset - document.documentElement.clientTop;
      const rect = this._toolbarDiv.getBoundingClientRect();
      changes.toolbarLeft = rect.left;
      changes.toolbarWidth = rect.width;
    }

    this.setState(changes, () => {
      this.updateToolbarHeight();
    });
  }

  updateToolbarHeight() {
    if (this._toolbarContentsWrapper) {
      this.setState({
        toolbarHeight: this._toolbarContentsWrapper.clientHeight
      });
    }
  }

  getWrapperStyle() {
    if (this.state.stickToTop) {
      return {
        top: `${this.state.toolbarTop}px`,
        left: `${this.state.toolbarLeft}px`,
        width: `${this.state.toolbarWidth}px`
      };
    }

    return {};
  }

  renderToolbarPlaceholder() {
    // Renders a div with the same height as the toolbar
    //
    // This is intended to preserve the vertical position of elements on
    // the page when the toolbar switches from to the sticky version.
    if (this.state.stickToTop) {
      return <div style={{ height: this.state.toolbarHeight }} />;
    }

    return null;
  }

  render() {
    return (
      <div
        className={cn('cp-sticky-toolbar', this.props.className)}
        ref={el => {
          this._toolbarDiv = el;
        }}
      >
        <div
          className={cn('toolbar-contents-wrapper', {
            sticky: this.state.stickToTop
          })}
          style={this.getWrapperStyle()}
          ref={el => (this._toolbarContentsWrapper = el)}
        >
          {this.props.children}
        </div>
        {this.renderToolbarPlaceholder()}
      </div>
    );
  }
}

StickyToolbar.propTypes = {
  className: PropTypes.string,
  getOffsetForStickyToolbar: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default StickyToolbar;
